<template>
    <v-flex d-flex :class="dialogmode? 'xs12' : 'xs12 md12 lg2'">
            
        <v-card color="#fff" light>

            <v-card-title primary class="title">Speichern</v-card-title>
            <v-card-text>
                <v-container fluid grid-list-md>
                    <!-- Save and Help Element-->
                    <v-layout row justify-center>

                            <v-btn 
                                flat 
                                fab 
                                class="lime darken-4" 
                                small 
                                v-on:click.stop="submitted(true, false)">
                                <v-icon small>done</v-icon>
                            </v-btn>
                            <v-btn 
                                v-if="duplicateable"
                                flat 
                                fab 
                                class="lime darken-4" 
                                small 
                                v-on:click.stop="submitted(true, true)">
                                <v-icon small>done_all</v-icon>
                            </v-btn>
                            <v-btn flat fab class="black" dark small v-on:click.stop="submitted(false, false)">
                                <v-icon small>close</v-icon>
                            </v-btn>

                    </v-layout> 
                    <v-divider class="my-3 grey"></v-divider>
                    <v-layout row justify-center>
                       
                        <v-flex d-flex xs12>
                            <v-expansion-panel>
                                <v-expansion-panel-content>
                                    <div slot="header">
                                        <span><v-icon large>contact_support</v-icon>Hilfe/Info</span>
                                    </div>
                                    <v-card light flat color="transparent">
                                        <v-card-text v-html="helptext">                                    
                                        </v-card-text>
                                    </v-card>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                            
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-card-text>
        </v-card>
    </v-flex>
</template>
<script>
    
    export default { 
    name: "formsave",
    components: {       
        
    },
    props:[
        'dialogmode',
        'duplicateable',
        'helptext'
    ],
    data() {
        return {                   
           
        }
    },
    computed: {
        
    },
    methods: {
        submitted(submitted, duplicate) {
            this.$emit('submitted', submitted, duplicate)
        }
        
    }        
}
</script>